import React, { FunctionComponent, useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";

//OUTSIDE COMPONENTS
import { makeStyles } from '@material-ui/core/styles';
//CSS, STYLES & MEDIA ASSETS
import {useSpring, animated} from 'react-spring'
//import delay from 'delay';

interface SliderMenuProps{

}

// const Teste = Keyframes.Spring({
//   in: async next => {
//     await next({
//       transform: 'translateX(0%)',
//     });
//   },
//   out: async next => {
//     await delay(700);
//     await next({
//       transform: 'translateX(-100%)',
//     });
//   },
// });


const useStyles = makeStyles((theme) => ({

}));

const SliderMenu : FunctionComponent<SliderMenuProps> = ({children}) =>{

    const { t } = useTranslation();

    const classes = useStyles();

    const props =  useSpring({opacity: 1, from: {opacity: 0}})
    //const props =  useSpring({ transform: "translateX(0em)", from: {transform: "translateX(-50em)", transition: "right 2s"}})


        return (
          <>
            <animated.div style={props}>
              {children}
            </animated.div>
          </>
        );
    }

export default SliderMenu
